import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["submitButton"];

  connect() {
    this.element.addEventListener("change", this.validate.bind(this));
    this.validate();
  }

  validate() {
    const isValid = [...this.element.elements].every((el) => el.validity.valid);
    this.submitButtonTarget.disabled = !isValid;
  }
}
